<template>
  <div class="product-edit">
    <VLoader v-if="isLoading" />

    <div v-if="!isLoadingFirst" v-show="!isLoading">
      <VEmpty v-if="!product" />

      <div
        v-else
        class="block-opacity"
        :class="{ 'opacity-active': isShowFormInner }"
      >
        <div class="product-edit__header">
          <h2 class="text-bold">
            {{
              getMessageByLang("pageTitleChangeProduct", "Изменение продукта")
            }}
          </h2>

          <div class="app-header-control">
            <Button @click="cancel">{{
              getMessageByLang("cancel", "Отмена")
            }}</Button>
            <Button @click="handleSave" :theme-color="'primary'">
              {{ getMessageByLang("btnSave", "Сохранить") }}
            </Button>
          </div>
        </div>

        <div class="product-edit__form">
          <div class="product-edit__form-create">
            <Form
              ref="productFormCreate"
              :ignoreModified="false"
              @submit="submitForm"
              :initialValues="product"
            >
              <ProductForm
                ref="RefProductForm"
                :isShowSubmit="false"
                :product="product"
              />
            </Form>
          </div>

          <div class="product-edit__photos">
            <ProductPhotos ref="RefPhotos" :photos="product?.images || []" />
          </div>

          <div class="product-edit__options">
            <ProductOptions
              ref="RefProductOptions"
              :listOptions="product?.options || []"
            />
          </div>
        </div>

        <div class="product-edit__footer">
          <Button @click="handleSave" :theme-color="'primary'">
            {{ getMessageByLang("btnSave", "Сохранить") }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getMessageByLang } from "@/utils/translate.js";
import { getRespErrorMessage } from "@/utils/errors.js";
import { getRole } from "@/utils/router";

import Api from "@/api";

import { Form } from "@progress/kendo-vue-form";
import { Button } from "@progress/kendo-vue-buttons";

import VLoader from "@/ui-kit/components/VLoader.vue";
import ProductForm from "@/components/forms/ProductForm.vue";
import VEmpty from "@/ui-kit/components/VEmpty.vue";
import ProductOptions from "@/components/product/ProductOptions.vue";
import ProductPhotos from "@/components/product/ProductPhotos.vue";

const route = useRoute();
const router = useRouter();

const isLoading = ref(true);
const product = ref(null);
const RefProductForm = ref(null);
const RefProductOptions = ref(null);
const RefPhotos = ref(null);
const isLoadingFirst = ref(true);
const isShowFormInner = ref(false);

const handleSave = () => {
  const formValue = RefProductForm.value.kendoForm.values;
  const optionsVal = RefProductOptions.value.getData();

  const productVal = {
    ...formValue,
    base_price: formValue.base_price
      ? Number(formValue.base_price.replace(/\s/g, ""))
      : null,
    category_id: RefProductForm.value.selectedItem
      ? RefProductForm.value.selectedItem
      : product.value.category_id,
    options: optionsVal,
  };

  handleCreateSubmit(productVal);
};

const cancel = () => {
  showListPage();
};

const submitForm = () => {};

const prepareOptions = (list) => {
  return list.map((item) => {
    if (item.type.value === "single") {
      item.type = "single";
    } else {
      item.type = "multiple";
    }

    item.price = 0;
    item.visible = 1;
    item.items = item.items.map((subItem) => {
      return {
        ...subItem,
        visible: 1,
      };
    });

    return item;
  });
};

const showListPage = () => {
  const role = getRole();

  if (role === "supplier") {
    router.push("/supplier/products");
  } else if (role === "client") {
    router.push("/client/products");
  } else {
    router.push("/admin/products");
  }
};

const handleCreateSubmit = async (data = null) => {
  try {
    isLoading.value = true;

    if (!data) {
      isLoading.value = false;
      return;
    }

    const item = {
      ...product.value,
      ...data,
    };

    const optionsList = prepareOptions(item.options);
    item.options = JSON.parse(JSON.stringify(optionsList));
    delete item.images;

    const response = await Api.product.edit(item);
    if (response.status !== 200) {
      alert(getMessageByLang('saveError', "Ошибка сохранения"));
      return;
    }

    const images = RefPhotos.value.getPhotos();
    if (images && images[0]) {
      await Api.product.saveImg(data.id, images);
    }

    const listImagesForRemove = RefPhotos.value.getPhotosRemove();
    if (listImagesForRemove && listImagesForRemove) {
      for (const image of listImagesForRemove) {
        await Api.product.removePhoto(image);
      }
    }

    showListPage();
  } catch (err) {
    console.error(err);
    const message = getRespErrorMessage(err);
    alert(message);
  } finally {
    isLoading.value = false;
  }
};

const getProduct = async () => {
  try {
    isLoading.value = true;
    isLoadingFirst.value = true;

    const id = route?.params?.id;
    const response = await Api.product.get(id);

    if (response.status === 200) {
      product.value = response.data.data;
    }
  } catch (err) {
    console.error(err);
  } finally {
    isLoading.value = false;
    isLoadingFirst.value = false;
    setTimeout(() => {
      isShowFormInner.value = true;
    }, 1100);
  }
};

onMounted(() => {
  getProduct();
});
</script>

<style lang="scss" scoped>
.product-edit {
  &__header {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>